import React, { useState } from "react";

import PropTypes from "prop-types";

import keyExistsOn from "common/lodash/keyExistsOn";

import { FaCheckCircle } from "components/atoms/Icon/fa/FaCheckCircle";
import { FaTimesCircle } from "components/atoms/Icon/fa/FaTimesCircle";

const renderCheck = (check) => {
  return check ? (
    <td>
      <FaCheckCircle className="m-auto text-bbc-brand-600" size={16} />
    </td>
  ) : (
    <td>
      <FaTimesCircle className="m-auto text-bbc-red-400" size={16} />
    </td>
  );
};

const TdBody = ({ tableItem, emi }) => {
  if (tableItem.contact_us) {
    return (
      <td colSpan="5" className="text-center">
        Contact us for details
      </td>
    );
  }
  if (emi) {
    return (
      <React.Fragment>
        {renderCheck(tableItem.online_registration)}
        {renderCheck(tableItem.multiple_account)}
        {renderCheck(tableItem.support_transactions)}
        {renderCheck(tableItem.physical_card)}
        {tableItem.other_features && (
          <>
            {typeof tableItem.other_features === "boolean" ? (
              renderCheck(tableItem.other_features)
            ) : (
              <td className="px-4">
                <span className={"block text-center"}>
                  {tableItem.other_features}
                </span>{" "}
              </td>
            )}
          </>
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {renderCheck(tableItem.online_banking)}
      {renderCheck(tableItem.personal_visit)}
      {renderCheck(tableItem.credit_card)}
      {renderCheck(tableItem.debit_card)}
      {tableItem.initial_deposit && (
        <>
          {typeof tableItem.initial_deposit === "boolean" ? (
            renderCheck(tableItem.initial_deposit)
          ) : (
            <td className="px-4">
              <span className={"block text-center"}>
                {tableItem.initial_deposit}
              </span>{" "}
            </td>
          )}
        </>
      )}
    </React.Fragment>
  );
};

const BankingTable = ({ data, emi, description, thead, ...props }) => {
  const renderTbody =
    data.length > 0 &&
    data.map((item, itemIdx) => {
      return (
        Array.isArray(item.banks) &&
        item.banks.length > 0 &&
        item.banks.map((tableItem, index) => {
          return (
            <tr
              key={index}
              className={`${
                itemIdx % 2 === 0 ? "bg-white" : "bg-bbc-brand-100"
              }  text-sm  leading-6`}
            >
              {index == 0 && (
                <td
                  className={`pl-7 pr-6 font-medium leading-6 text-bbc-brand-800 ${
                    emi && " text-left"
                  } `}
                  rowSpan={item.banks.length}
                >
                  {item.name}
                </td>
              )}
              <td className={" py-1.5 text-left"}>{tableItem.name}</td>
              <TdBody tableItem={tableItem} emi={emi} />
            </tr>
          );
        })
      );
    });
  const [theadArr] = useState(() => {
    if (
      keyExistsOn(data[0].banks[0], "other_features") ||
      keyExistsOn(data[0].banks[0], "initial_deposit")
    )
      return thead;

    return [...thead].slice(0, thead.length - 1);
  });

  return (
    <div className={props.className}>
      <div
        className={
          "overflow-hidden rounded-2xl border border-bbc-neutral-400  bg-white"
        }
        style={{ paddingBottom: description?.length > 0 ? "22px" : "0" }}
      >
        <table className="w-full">
          <thead className="border-b ">
            <tr>
              {theadArr.map((item, index) => (
                <th
                  key={index}
                  className={`${index === 0 && "pl-7"} ${
                    index < 2 && "text-left"
                  }  p-3 text-sm font-medium leading-6 text-bbc-brand-700`}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="">{renderTbody}</tbody>
        </table>
        {description?.length > 0 && (
          <p
            className="mt-4 px-7 text-sm leading-6"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        )}
      </div>
    </div>
  );
};

export default BankingTable;

BankingTable.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
  emi: PropTypes.bool,
};
BankingTable.defaultProps = {
  data: [],
  children: <></>,
};
